import React from 'react'
import '../Project.css';
import Image1 from '../../Gemco-Website-Images/projects/Fly_Dubai.webp';

const Project_one = () => {

  return (
    <>

      <div className='project_1_work' id="workBanner">

        <div className="container project_our_work">

          <div className="heading">
            <h1>FlyDubai Headquarters</h1>
          </div>

          <hr></hr>
          <div className='project_section'>
            <div className="project_section_content">
              <h1 className="project_scope">Scope of Work</h1>
              <p>Corporate headquarters of flydubai — the UAE's government-owned low-cost airline operating to 100+ destinations across the
                Middle East, Africa, Europe and Asia. Located at Dubai Aviation City, serving as the airline's primary operational and
                administrative hub.</p>
              <p>MAIN CONTRACTOR : -</p>
              <p>MEP CONTRACTOR : Transgulf</p>
              <p>GEMCO SCOPE OF WORKS : MEP works</p>
              {/* <h2 className="project_years">2014 – 2022</h2> */}
            </div>
            <div className='project_1_card'>
              <img className="project_one_image" width="500" height="300" src={Image1} alt="Project" />
            </div>
          </div>
        </div>
      </div>

    </>


  )
}

export default Project_one